import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import logo from 'assets/img/ta-loader.gif';
import styles from './TimifyLoader.module.scss';

export interface ITimifyLoader extends HTMLAttributes<HTMLDivElement> {
  fullHeight?: boolean;
  overlay?: boolean;
}

const TimifyLoader: FC<ITimifyLoader> = (props) => {
  const { fullHeight, className, overlay } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.fullHeight]: fullHeight,
    [styles.overlay]: overlay,
  });

  return (
    <div className={rootClassName}>
      <img src={logo} alt='timify loader logo' />
    </div>
  );
};

export default TimifyLoader;
